import type { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  documentTitleEnvironmentLabel: 'Dev',
  apiBaseUrl: '/api',
  enableMockApi: {
    proposals: false,
    knowledge: false,
    smartDiscovery: false,
    scotsman: false,
    opportunityAssessment: false,
    assets: false,
    relatedAssets: false,
    accounts: false,
  },
  features: {
    relatedAssetsTab: true,
  },
  mockApiTiming: {
    assets: {
      responseDelayMs: 1200,
      analysisReadyAfterGetPolls: 3,
    },
  },
  logLevel: 'info',
  developmentContextHud: 'always',
  auth: {
    enabled: true,
    tenantId: 'ccce7f5e-a35f-4bc3-8e63-b2215e7d14f9',
    // Momentum Web – Angular (Dev)
    clientId: 'b0105ade-6ccb-44ce-a568-9897e702c990',
    // Momentum App API (Dev) delegated scope
    apiScopes: ['api://dc95e023-5b90-4732-adf9-bd40922e43b1/api.access'],
    redirectUri: 'https://momentum-dev.zuehlke.com/',
    postLogoutRedirectUri: 'https://momentum-dev.zuehlke.com/',
  },
  enableAppVersionCheck: true,
};
